<script setup lang="ts">
import { computed, onMounted } from 'vue'
import GroupsTable from '@/components/Sidebar/GroupsTable.vue'
import StudentsTable from '@/components/Sidebar/StudentsTable.vue'
import { userModule } from '@/store/user/module'
import { organizationModule } from '@/store/organization/module'

const currentUser = computed(() => {
    return userModule.state.user
})

const currentOrg = computed(() => {
    return organizationModule.getters.getCurrentOrganization()
})

onMounted(async () => {
    await organizationModule.actions.fetchCurrentOrganization()
})
</script>

<template>
    <div class="sidebar">
        <div v-if="currentOrg" class="sidebar__org-name">
            {{ currentOrg.name }}
        </div>
        <div v-if="currentUser" class="sidebar__user-name">
            {{ [ currentUser.firstName, currentUser.lastName ].join(' ') }}
        </div>
        <GroupsTable class="sidebar__groups-table" />
        <StudentsTable class="sidebar__students-table" />
    </div>
</template>

<style lang="scss" scoped>


.sidebar {
    box-sizing: border-box;
    width: 400px;
    padding: 35px 30px 100px;

    &__org-name {
        color: $ash;
        font-size: 15px;
        line-height: 20px;
        padding-left: 16px;
        margin-bottom: 7px;
    }

    &__user-name {
        font-size: 20px;
        line-height: 27px;
        font-weight: 600;
        padding-left: 16px;
        margin-bottom: 14px;
    }

    &__groups-table {
        margin-bottom: 30px;
    }
}
</style>

